let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9yemY")).then(() => parcelRequire('7vmw8'));